<template>
  <div :class="[isLoading ? 'spinner' : '']">
    <div :class="[isLoading ? 'opacity-25' : '']">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="sass" scoped>
  .error-message
    @apply my-2
    font-size: 13px
    color: #FA3434

  .spinner
    background: url('/dots.svg')
    pointer-events: none
    @apply h-full bg-center bg-no-repeat
    &.fixed-size
      background-size: 60px

  .error
    input
      @apply bg-red-100 border-4 border-red-500
    textarea
      @apply bg-red-100 border-4 border-red-500
    :deep(.uppy)
      &:not(.uppy-ProgressBar)
        @apply bg-red-100
        box-shadow: 0 0 0 4px #F56565
    :deep(.vue-tel-input)
      @apply bg-red-100 border-4 border-red-500
      .vti__input
        @apply bg-red-100
    :deep(#autosuggest)
      input
        @apply bg-red-100 border-4 border-red-500
    :deep(.multiselect)
        @apply bg-red-100 rounded-[12px] border-4 border-red-500
        .multiselect__tags
          @apply bg-red-100
          .multiselect__single
            @apply bg-red-100
</style>
